import React from 'react';
import { useTranslation } from 'react-i18next';
import DropDownInput from '../dropDownInput/dropDownInput';
import { useVenueBranchAccess } from '../../hooks/useVenueBranchAccess';
import { VenueBranchSelection } from '../../hooks/useVenueBranchAccess';

export type VenueBranchDropdownProps = {
  selectedBranch?: VenueBranchSelection;
  onSelect: (branch: VenueBranchSelection) => void;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
};

const VenueBranchDropdown: React.FC<VenueBranchDropdownProps> = ({
  selectedBranch,
  onSelect,
  placeholder,
  disabled,
  className,
}) => {
  const { t } = useTranslation();
  const { venueBranchOptions } = useVenueBranchAccess();

  return (
    <div className={className}>
      <DropDownInput
        options={venueBranchOptions}
        selected={selectedBranch?.value}
        onSelect={(value) => {
          const branch = venueBranchOptions.find((opt) => opt.value === value);
          if (branch) {
            onSelect({ label: branch.label, value: branch.value });
          }
        }}
        placeholder={
          placeholder || t('universalStaffLoginModal.selectVenueBranch')
        }
        disabled={disabled}
      />
    </div>
  );
};

export default VenueBranchDropdown;
